// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2zrx5","modalForm":"UpgradeEpcsModal_modalForm__1rMmz","modalFooter":"UpgradeEpcsModal_modalFooter__3l32W"};